import { DATA_TEST_ID_ATTRIBUTE_NAME, DATA_TEST_ID_SELECTION } from './contants';

export const compareFunctionForSort = (currentItem, nextItem) => {
  if (currentItem < nextItem) {
    return -1;
  }
  if (currentItem > nextItem) {
    return 1;
  }
  return 0;
};

export const buildDataTestId = (prefix, name) => {
  return prefix ? `${prefix}_${name}` : undefined;
};

export const buildFullDataTestId = (fileOrElementName, elementName?: string) => {
  const elementNameWithUnderscore = elementName ? `_${elementName}` : '';
  return `selections__${fileOrElementName}${elementNameWithUnderscore}`;
};

export const buildDataTestIdAttribute = (prefix?: any | string, name?: string) => ({
  [DATA_TEST_ID_ATTRIBUTE_NAME]: name ? buildDataTestId(prefix, name) : prefix,
});

export const replaceCebabCase = (str?: string) => {
  return (
    str
      ?.replaceAll(/([a-z])([A-Z])/g, '$1-$2')
      .toLowerCase()
      .replaceAll('.', '-') || ''
  );
};

export const buildDataTestIdFromNestedName = (name?: string, typeElement = 'input', value = '') => {
  const criteriaNumberArr = name?.split('.').splice(0, 2);
  const criteriaNumber = criteriaNumberArr && criteriaNumberArr?.length > 1 ? `${criteriaNumberArr.join('-')}_` : '';
  const inputName = replaceCebabCase(criteriaNumberArr && criteriaNumberArr?.length > 1 ? name?.split('.')[2] : name);

  const valueStr = value ? `-${replaceCebabCase(value)}` : '';
  const dataTestId = buildFullDataTestId(
    DATA_TEST_ID_SELECTION,
    `${criteriaNumber}${typeElement}-${inputName}${valueStr}`,
  );

  return dataTestId;
};

export const makeScrollBar = (sizePx: number) => ({
  '&::-webkit-scrollbar': {
    width: `${sizePx}px`,
    height: `${sizePx}px`,
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#DFF2F5',
    '&:hover': {
      backgroundColor: '#BFE5EB',
    },
  },
});

export const getFullName = (
  person?: { firstName: Nullable<string>; lastName: Nullable<string>; middleName?: Nullable<string> } | null,
) => {
  if (!person) return '';

  const { firstName, lastName, middleName } = person;
  const middle = middleName ? `${middleName[0].toUpperCase()}. ` : '';
  return `${firstName || ''} ${middle}${lastName || ''}`;
};
